import $AC from './utils/AccessList'

const getters = {
  authenticated: state => !!state.user.id && (state.user.type === 'LOGIN' || state.user.type === 'LOGIN_SWITCH'),
  // User is pending MFA verification
  mfaPending: state => state.user.type === 'MFA_PENDING',
  // User is pending MFA enrollment
  mfaEnroll: state => state.user.type === 'MFA_ENROLL',
  name: state => state.user.name,
  loading: state => state.loading,
  status: state => state.status,
  switched: state => !!state.user.requestingUser,
  user: state => state.user,
  // Check if a user has permissions against access list
  // Kept in Auth module for easy access to user object
  hasPermission: state => (op) => {
    // This check is necessary because the access
    // control module will throw an error if the
    // user has no roles. In the future this might
    // be fixed in the module.
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!state.user.roles) {
      return $AC.can({
        user: { roles: state.user.roles },
      }, op)
    }
    return false
  },
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/auth/auth.getters.js